import React from 'react';
import { useEffect, useState } from 'react';
import customersStorageService from 'src/app/customers/services/customers-storage-service';
import projectsStorageService from 'src/app/projects/services/projects-storage-service';
import globalStorageService from 'src/global/services/global-storage-service';
import cmsService from 'src/services/cms-service';
import { redirectToShopify } from 'src/shared/utils/redirect';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { useSearchParams } from 'react-router-dom';
import Loader from 'src/shared/components/loader/Loader';
import authService from 'src/services/auth-service';
import ErrorScreen from 'src/shared/components/error-screen/ErrorScreen';
import loginStorageService from '../../services/login-storage-service';

const Oauth = () => {
    const navigate = useAppNavigation();
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const [error, setError] = useState<Error>();

    useEffect(() => {
        const onSigninSuccess = async () => {
            let permissions = null;
            try {
                permissions = await authService.fetchUserPermissions(code as string);
            } catch (error) {
                setError(error as Error);
            }
            const redirectTo = loginStorageService.getRedirectPath();

            //shopify redirect
            if (redirectTo === 'shopify') {
                redirectToShopify();
                return;
            }

            //Preload and store feature test config
            const cmsFeatureTestConfig = await cmsService.getFeatureTestConfig();
            globalStorageService.setFeatureTestConfig(cmsFeatureTestConfig);
            cmsService.getFeatureTestConfig().then(config => {
                globalStorageService.setFeatureTestConfig(config);
                return config;
            });

            loginStorageService.setTermsOfUseConsent(false);
            if (permissions && !permissions.tnc_consent) {
                navigate.toTermsOfUse();
                return;
            }

            projectsStorageService.clearAll();
            customersStorageService.clearAll();
            loginStorageService.setTermsOfUseConsent(true);

            if (redirectTo) {
                window.location.assign(decodeURIComponent(redirectTo));
            } else {
                navigate.toCustomers();
            }
        };

        if (code) {
            onSigninSuccess();
        }
    }, []);

    if (error) {
        return <ErrorScreen error={error} />;
    }

    return <Loader />;
};
export default Oauth;
